<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
    content-class="product-detail-full-screen-dialog"
  >
    <v-toolbar fixed height="56px" class="toolbar">
      <v-toolbar-items class="toolbar-side-icon"> </v-toolbar-items>

      <v-toolbar-title
        class="text-xs-center ml-0 toolbar-title"
        style="flex-grow: 1;"
      >
        商品詳細
      </v-toolbar-title>

      <v-toolbar-items class="toolbar-side-icon">
        <v-btn flat icon color="primary" @click.native="closeAllDialogs">
          <img src="../../assets/images/close_icon.svg" alt="close" />
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <ProductDetailPage
      :page-top-id="pageTopId"
      :selected-gallery-image-index="selectedGalleryImageIndex"
      :price-combook-binding="priceCombookBinding"
      @update:selectedGalleryImageIndex="selectedGalleryImageIndex = $event"
      @show-binding-sample-dialog="bindingSampleDialog = true"
    />

    <BindingSampleFullScreenDialog
      :dialog="bindingSampleDialog"
      @back="bindingSampleDialog = false"
      @close-dialog="closeAllDialogs"
    />
  </v-dialog>
</template>

<script>
import ProductDetailPage from "./ProductDetailPage.vue";
import BindingSampleFullScreenDialog from "./BindingSampleFullScreenDialog.vue";

export default {
  components: {
    ProductDetailPage,
    BindingSampleFullScreenDialog
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    priceCombookBinding: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedGalleryImageIndex: 0,
      bindingSampleDialog: false
    };
  },
  computed: {
    pageTopId() {
      return "product-detail-page-top";
    }
  },
  methods: {
    closeAllDialogs() {
      this.bindingSampleDialog = false;

      // 再度ダイアログを開いた時のためにリセット処理を行う
      this.selectedGalleryImageIndex = 0;
      this.goToTop();

      this.$emit("close-dialog");
    },
    goToTop() {
      const elem = document.getElementById(this.pageTopId);
      if (elem) {
        elem.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }
  }
};
</script>

<style>
.product-detail-full-screen-dialog {
  scroll-padding-top: 72px; /* toolbarの高さを考慮して、スクロールの余白を追加 */
  overscroll-behavior: none;
}
</style>

<style scoped>
.toolbar {
  background-color: #ffffff;
  border-color: #0000001f;
  border-style: solid;
  border-width: 0 0 1px 0;
  box-shadow: none;
}
.toolbar-side-icon {
  width: 48px;
}
.toolbar-title {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
}
</style>
